import { Mensagem, OrigemMensagem, ArquivoMensagem } from '../../../models/mensagem';
import { MensagemProvider } from '../../../providers/mensagem/mensagem';
import { EmpresaLocalProvider } from '../../../providers/empresa-local/empresa-local';
import { BrComService } from '../../../service/BrComService';
import { FotoProvider } from '../../../providers/foto/foto';
import { Conversa } from './conversa';

export abstract class ConversaArea extends Conversa {

    constructor(protected mensagemProvider: MensagemProvider,
        protected empresaLocalProvider: EmpresaLocalProvider,
        protected brComService: BrComService,
        protected fotoProvider: FotoProvider) {
            super(mensagemProvider, empresaLocalProvider, brComService, fotoProvider);
    }

    protected criarMensagemSimplesEnvio(textoMensagem: string, idUsuarioDestino: number): Mensagem {
        const dataHora = this.mensagemProvider.getDataHoraFormatado();
        const mensagem = this.mensagemProvider.criarMensagemSimples({
            idEnvio: new Date().getTime(),
            idMensagemUsuario: 0,
            mensagem: textoMensagem,
            origem: OrigemMensagem.DIREITA,
            idUsuarioDestino: idUsuarioDestino,
            idUsuarioOrigem: this.empresa.IdUsuario,
            textoTipoMensagem: '',
            podeSerRespondida: false,
            dataHora: this.getTimestamp(),
            data: dataHora.data,
            hora: dataHora.hora
        });
        mensagem.pendente = true;
        mensagem.nomeUsuario = this.empresa.NomeUsuario;
        return mensagem;
    }

    protected criarMensagemImagemEnvio(idUsuarioDestino: number): Mensagem {
        const dataHora = this.mensagemProvider.getDataHoraFormatado();
        const mensagem = this.mensagemProvider.criarMensagemImagem({
            idEnvio: new Date().getTime(),
            idMensagemUsuario: 0,
            link: "",
            origem: OrigemMensagem.DIREITA,
            idUsuarioDestino: idUsuarioDestino,
            idUsuarioOrigem: this.empresa.IdUsuario,
            textoTipoMensagem: '',
            podeSerRespondida: false,
            dataHora: this.getTimestamp(),
            data: dataHora.data,
            hora: dataHora.hora,
        })
        mensagem.pendente = true;
        mensagem.nomeUsuario = this.empresa.NomeUsuario;
        return mensagem;
    }

    protected criarMensagemArquivoEnvio(idUsuarioDestino: number, arquivo: ArquivoMensagem): Mensagem {
        const dataHora = this.mensagemProvider.getDataHoraFormatado();
        const mensagem = this.mensagemProvider.criarMensagemArquivo({
            idEnvio: new Date().getTime(),
            idMensagemUsuario: 0,
            arquivo: arquivo,
            origem: OrigemMensagem.DIREITA,
            idUsuarioDestino: idUsuarioDestino,
            idUsuarioOrigem: this.empresa.IdUsuario,
            textoTipoMensagem: '',
            podeSerRespondida: false,
            dataHora: this.getTimestamp(),
            data: dataHora.data,
            hora: dataHora.hora
        })
        mensagem.pendente = true;
        mensagem.nomeUsuario = this.empresa.NomeUsuario;
        return mensagem;
    }

}


// WEBPACK FOOTER //
// ./src/pages/shared/conversa/conversa-area.ts